import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { HardHat, Logs } from 'lucide-react'
import type { WorkflowDutyLink } from '../types'

// Deep-link to the sessions list filtered to this workflow's slug. Matches the
// query params AllSessionsListView restores from the URL (slug + sort).
export function sessionsHref(slug: string): string {
  const search = new URLSearchParams({
    slug,
    sort_by: 'created_at',
    sort_order: 'desc',
  })
  return `/sessions?${search.toString()}`
}

export function DutyLink({ duty }: { duty: WorkflowDutyLink }) {
  // Pass the duty name via nav state so the opened tab shows a real title
  // instead of the "Duty (<id>)" placeholder.
  const state = useMemo(() => ({ dutyName: duty.name }), [duty.name])
  return (
    <div className="flex items-center gap-2">
      <Link
        to={`/duties/${duty.id}`}
        state={state}
        className="inline-flex min-w-0 items-center gap-1.5 text-primary hover:underline">
        <HardHat className="size-3.5 shrink-0" />
        <span className="truncate">{duty.name ?? 'View duty'}</span>
      </Link>
      {/* The link exists but the duty has the workflow switched off, so it won't
          run there. Say so rather than let the link read as live. */}
      {!duty.active && (
        <span className="shrink-0 text-xs text-muted-foreground">
          switched off
        </span>
      )}
    </div>
  )
}

export function SessionsLink({ slug }: { slug: string }) {
  return (
    <Link
      to={sessionsHref(slug)}
      className="inline-flex items-center gap-1.5 text-primary hover:underline">
      <Logs className="size-3.5 shrink-0" />
      View sessions
    </Link>
  )
}
